<template>
  <a :href="`tel:${formatedPhoneNumber}`">
    <slot>
      {{ formatedPhoneNumber }}
    </slot>
  </a>
</template>

<script>
import { formatIntlPhoneNumber } from '@/util/formatters';

export default {
  name: 'BaseTelephone',
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  computed: {
    formatedPhoneNumber() {
      return formatIntlPhoneNumber(this.phoneNumber);
    },
  },
};
</script>
